export class SubmitResult {
    static $type = 'Web.SubmitResult';

    workItemId: string;

    title: string;
}
